// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  background: var(--gc-background-color);
  display: inline-block;
  cursor: pointer;
}

.circle-icon, .gray, .red, .purple, .yellow, .green, .teal, .blue {
  border-radius: 50%;
  height: 5rem;
  width: 5rem;
  font-size: 2rem;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.blue {
  background: rgb(58, 134, 180);
  background: linear-gradient(45deg, rgb(0, 197, 210) 0%, rgb(0, 116, 173) 45%, rgb(24, 150, 215) 100%);
}

.teal {
  background: rgb(58, 134, 180);
  background: linear-gradient(212.37deg, #1189C7 8.83%, #26D1C7 32.52%, #00C5D2 57.09%, #4D8275 94.63%);
}

.green {
  background: rgb(180, 255, 218);
  background: linear-gradient(45deg, rgb(180, 255, 218) 0%, rgb(76, 188, 134) 45%, rgb(10, 139, 76) 100%);
}

.yellow {
  background: rgb(224, 242, 112);
  background: linear-gradient(45deg, #e1f270 0%, rgb(255, 207, 35) 45%, rgb(255, 214, 153) 100%);
}

.purple {
  background: rgb(159, 152, 203);
  background: linear-gradient(45deg, rgb(38, 40, 43) 0%, rgb(60, 19, 149) 45%, rgb(159, 152, 203) 100%);
}

.red {
  background: rgb(255, 165, 146);
  background: linear-gradient(45deg, rgb(19, 3, 3) 0%, rgb(211, 47, 47) 45%, rgb(255, 165, 146) 100%);
}

.gray {
  background: rgb(242, 242, 242);
  background: linear-gradient(45deg, rgb(242, 242, 242) 0%, rgb(73, 80, 87) 33%, rgb(114, 130, 146) 66%, rgb(198, 215, 232) 100%);
}

.title {
  margin-left: 14px;
  overflow-wrap: anywhere;
}

.card {
  padding: 14px;
}

.check {
  top: 0;
  right: 0;
  margin: 14px;
}

.circle-success {
  border-radius: 50%;
  width: 21px;
  height: 21px;
  background: #4cbc86;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-card-item/v-card-item.component.sass"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,sCAAA;EACA,qBAAA;EACA,eAAA;AACJ;;AACA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;;AAAA;EACI,6BAAA;EACA,qGAAA;AAGJ;;AAAA;EACI,6BAAA;EACA,qGAAA;AAGJ;;AAAA;EACI,8BAAA;EACA,uGAAA;AAGJ;;AAAA;EACI,8BAAA;EACA,8FAAA;AAGJ;;AAAA;EACI,8BAAA;EACA,qGAAA;AAGJ;;AAAA;EACI,8BAAA;EACA,mGAAA;AAGJ;;AAAA;EACI,8BAAA;EACA,+HAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,uBAAA;AAGJ;;AAFA;EACI,aAAA;AAKJ;;AAHA;EACI,MAAA;EACA,QAAA;EACA,YAAA;AAMJ;;AAHA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAMJ","sourcesContent":[":host\n    width: 100%\n    background: var(--gc-background-color)\n    display: inline-block\n    cursor: pointer\n\n.circle-icon\n    border-radius: 50%\n    height: 5rem\n    width: 5rem\n    font-size: 2rem\n    color: white\n    display: flex\n    justify-content: center\n    align-items: center\n    \n.blue\n    background: rgb(58,134,180)\n    background: linear-gradient(45deg, rgba(0,197,210,1) 0%, rgba(0,116,173,1) 45%, rgba(24,150,215,1) 100%)\n    @extend .circle-icon\n\n.teal\n    background: rgb(58,134,180)\n    background:  linear-gradient(212.37deg, #1189C7 8.83%, #26D1C7 32.52%, #00C5D2 57.09%, #4D8275 94.63%)\n    @extend .circle-icon\n\n.green\n    background: rgb(180,255,218)\n    background: linear-gradient(45deg, rgba(180,255,218,1) 0%, rgba(76,188,134,1) 45%, rgba(10,139,76,1) 100%)\n    @extend .circle-icon\n\n.yellow\n    background: rgb(224,242,112)\n    background: linear-gradient(45deg, #e1f270 0%, rgba(255,207,35,1) 45%, rgba(255,214,153,1) 100%)\n    @extend .circle-icon\n\n.purple\n    background: rgb(159,152,203)\n    background: linear-gradient(45deg, rgba(38,40,43,1) 0%, rgba(60,19,149,1) 45%, rgba(159,152,203,1) 100%)\n    @extend .circle-icon\n\n.red\n    background: rgb(255,165,146)\n    background: linear-gradient(45deg, rgba(19,3,3,1) 0%, rgba(211,47,47,1) 45%, rgba(255,165,146,1) 100%)\n    @extend .circle-icon\n\n.gray\n    background: rgb(242,242,242)\n    background: linear-gradient(45deg, rgba(242,242,242,1) 0%, rgba(73,80,87,1) 33%, rgba(114,130,146,1) 66%, rgba(198,215,232,1) 100%)\n    @extend .circle-icon\n\n.title\n    margin-left: 14px\n    overflow-wrap: anywhere\n.card\n    padding: 14px\n    \n.check\n    top: 0\n    right: 0\n    margin: 14px\n\n\n.circle-success\n    border-radius: 50%\n    width: 21px\n    height: 21px\n    background: #4cbc86\n    color: white\n    display: flex\n    justify-content: center\n    align-items: center"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
